import { useEffect, useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import { dateToString, notNullToDate } from "../../utilities/auxiliary-functions";
import { removeFormatDate } from "../../utilities/masks";
import { isEmpty } from "../../utilities/validators";
import VehicleRecord from "../records/vehicle.record";
import { FaTimes } from "react-icons/fa";
import { useAlertMessageContext } from "../../contexts/alert-message.context";
import { AlertMessageEnum } from "../../utilities/types";
import { Button } from '@mui/material';
import { useTranslateContext } from "../../contexts/translate.context";
import { usePartnerContext } from "../../contexts/partner.context";
import authService from "../../services/auth.service";
import FileResizer from "react-image-file-resizer";

export interface IVehicleCadastreModalProps {
    isEdit: boolean,
    show: boolean,
    record: any,
    onSubmitModal: any,
    onCancelModal: any
}

export const VehicleCadastreModal: React.FC<IVehicleCadastreModalProps> = (props: IVehicleCadastreModalProps) => {
    
    const alertContext = useAlertMessageContext();
    const { display } = useTranslateContext();
    let { partner } = usePartnerContext();

    const title : string = display.title.vehicle_cadastre;

    const [ invalidatedCadastreForm, setInvalidatedCadastreForm ] = useState(false);
    const [ sending, setSending ] = useState(false);

    // Vehicle
    const [ vehicleId, setVehicleId ] = useState(0);
    const [ estateId, setEstateId ] = useState(0);
    const [ plate, setPlate ] = useState('');
    const [ mark, setMark ] = useState('');
    const [ colorName, setColorName ] = useState('');
    const [ model, setModel ] = useState('');
    const [ manufacture, setManufacture ] = useState('');
    const [ created, setCreated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));
    const [ updated, setUpdated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));

    const [ image, setImage ] = useState(''); 

    async function isValidForm() {
        let result = true;
        let emptyRequired = false;

        if (emptyRequired) {
            await alertContext.show(AlertMessageEnum.FAIL, title, display.message.invalid.required);
            result = false;
        }

        setInvalidatedCadastreForm(!result);
        return result;
    }

    async function onClick_Confirm(event : any) {
        event.preventDefault();

        const isValid = await isValidForm();
        if (isValid) {
            try {
                setSending(false);
                const vehicle = fillVehicle();
                props.onSubmitModal(event, vehicle);
            } catch (error: any) {
                setSending(false);
                await alertContext.show(AlertMessageEnum.FAIL, title, error);
            }
        }
    }

    async function onClick_Cancel(event : any) {
        event.preventDefault();

        setInvalidatedCadastreForm(false);
        props.onCancelModal(event);
    }

    function clearVehicle() {
        setVehicleId(0);
        setEstateId(0);
        setPlate('');
        setMark('');
        setColorName('');
        setModel('');
        setManufacture('');
        setImage('');
        setCreated('');
        setUpdated('');
    }

    function fillDataForm(vehicle: any) {

        if (!isEmpty(vehicle)) {
            setVehicleId(vehicle.id);
            setEstateId(vehicle.estateId);
            setPlate(vehicle.plate);
            setMark(vehicle.mark);
            setColorName(vehicle.colorName);
            setModel(vehicle.model);
            setManufacture(vehicle.manufacture);
            setImage(vehicle.image);
            setCreated(notNullToDate(vehicle.created, 'dd/mm/yyyy HH:MM:ss'));  
            setUpdated(notNullToDate(vehicle.updated, 'dd/mm/yyyy HH:MM:ss'));  
        }
    }

    function fillVehicle() {

        const dataRegister = {
            id : vehicleId,
            estateId, 
            partnerId: partner.id,
            plate, 
            mark, 
            colorName, 
            model, 
            manufacture, 
            image,
            created : removeFormatDate(created), 
            updated : removeFormatDate(updated)
        };

        return dataRegister;
    } // fillVehicle

    async function initialize() {
        if (props.isEdit) {
            fillDataForm(props.record);
        } else {
            clearVehicle();
        }
    }

    useEffect(() => {
        if (isEmpty(partner))
            // eslint-disable-next-line react-hooks/exhaustive-deps
            partner = authService.currentPartner();

        if (props.show)
            initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.show]);

    function changeImage(event: any) {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            const extension = String(file.name).substring(String(file.name).lastIndexOf('.') + 1, String(file.name).length);
            FileResizer.imageFileResizer(file, 300, 300, extension, 100, 0,
                (uri: any) => {
                    setImage(uri);
                }, "base64"
            );
            /*
            let reader = new FileReader();
            reader.onload = (e: any) => {
                setImage(e.target.result);
            };
            reader.readAsDataURL(file);
            */
        } else {
            setImage('');
        }
    }

    function viewCadastreForm() {

        return (
            <>
                <Modal show={props.show}
                    size="lg"
                    aria-labelledby="modal-cadastre-vehicle-form"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title id="modal-cadastre-vehicle-form">{title}</Modal.Title>
                        <FaTimes className="isClickable" onClick={ onClick_Cancel } size={26}/>
                    </Modal.Header>
                    <Modal.Body>
                        <Form className="form" id="form-cadastre-vehicle" validated={invalidatedCadastreForm}>
                            <VehicleRecord
                                title={title}
                                isEdit={true}
                                identifier={vehicleId === 0}
                                viewOnly={false}
                                isViewAddress={false}

                                created={created}
                                updated={updated}
                                
                                plate={plate}
                                mark={mark}
                                colorName={colorName}
                                model={model}
                                manufacture={manufacture}
                                image={image}
                                setPlate={(value: any) => { setPlate(value); }}
                                setMark={(value: any) => { setMark(value); }}
                                setColorName={(value: any) => { setColorName(value); }}
                                setModel={(value: any) => { setModel(value); }}
                                setManufacture={(value: any) => { setManufacture(value); }}
                                
                                changeImage={(event: any) => { changeImage(event); }} 
                            />
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={ onClick_Cancel } variant="contained" color="secondary">{display.buttom.cancel}</Button>
                        <Button onClick={ onClick_Confirm } variant="contained" color="primary" disabled={sending}>
                            { sending ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null }{'  '}
                            { display.buttom.confirm }
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }

    return (
        <>
        { viewCadastreForm() }
        </>
    )
}

export default VehicleCadastreModal
